import React from "react";
import { ASSETS, CONTACT } from "@/data";
import { ExternalLink } from "lucide-react";
import { scrollToId, requestInquiry } from "@/components/site/ui";

const LINKS = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Immigration Services", id: "services" },
  { label: "FAQ", id: "faq" },
  { label: "Contact", id: "contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#F5F5F7] pt-20 lg:pt-28">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 border-t border-black/10 py-16">
          <div className="lg:col-span-5">
            <img src={ASSETS.logo} alt="Sleiman Immigration" className="h-12 w-auto" />
            <div className="mt-6 flex items-center gap-4">
              <img src={ASSETS.insignia} alt="RCIC Insignia" className="h-12 w-auto" />
            </div>
            <p className="mt-6 max-w-sm text-sm text-muted-foreground leading-relaxed">
              Personalized and professional Canadian immigration guidance from
              Ottawa, Canada&rsquo;s national capital.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-5">Explore</p>
            <ul className="space-y-3">
              {LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-nav-${l.id}`}
                    onClick={() => scrollToId(l.id)}
                    className="text-charcoal hover:text-crimson transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-5">Get in touch</p>
            <ul className="space-y-3 text-charcoal">
              <li>
                <a href={CONTACT.whatsappHref} target="_blank" rel="noopener noreferrer" className="hover:text-crimson transition-colors">
                  WhatsApp — {CONTACT.whatsapp}
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="hover:text-crimson transition-colors">
                  {CONTACT.email}
                </a>
              </li>
            </ul>
            <button
              onClick={() => requestInquiry("consultation")}
              data-testid="footer-book-btn"
              className="mt-8 inline-flex items-center gap-3 bg-crimson text-white px-7 py-3.5 text-sm uppercase tracking-[0.15em] hover:bg-crimson-dark transition-colors"
            >
              Book a Consultation
            </button>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-black/10 py-10">
          <p className="text-xs text-muted-foreground leading-relaxed max-w-4xl">
            Disclaimer: The information provided on this website is for general
            informational purposes only and does not constitute legal advice. It
            does not create a consultant–client relationship. Every immigration
            matter is unique; outcomes depend on individual circumstances and current
            regulations set by the Government of Canada. Sleiman Immigration makes no
            guarantee regarding the outcome of any application. This is temporary
            placeholder wording and will be replaced with the official disclaimer.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row justify-between gap-3 text-xs text-muted-foreground">
            <span>© {new Date().getFullYear()} Sleiman Immigration. All rights reserved.</span>
            <span>Ottawa, Ontario — Canada</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
